import type { WrapperProps } from "@/modules/companies/client/components/Wrapper/types"
import type { PagesRouterPage, PagesRouterPageProps } from "@/types"
import type { GetServerSideProps } from "next"

import { Teams } from "@/modules/companies/client/components/Teams/Teams"
import { Wrapper } from "@/modules/companies/client/components/Wrapper/Wrapper"
import { getServerSideTeamsProps } from "@/modules/companies/client/utils/getServerSideTeamsProps"

const CompanyTeams: PagesRouterPage<WrapperProps> = props => (
  <Wrapper {...props}>
    <Teams />
  </Wrapper>
)

const getServerSideProps: GetServerSideProps<PagesRouterPageProps<WrapperProps>> = async context =>
  getServerSideTeamsProps(context)

export { CompanyTeams as default, getServerSideProps }
